import { gsap } from 'gsap'

export class Transition {

  isCallable() {
    return window.innerWidth > 1024
  }
  init() {
    const overlay = document.getElementById('transition-overlay')
    const links = document.querySelectorAll('a:not([href]), a:not([href^="mailto:"])');

    links.forEach(link => {
      link.addEventListener('click', function (event) {

        const url = this.href

        if (url.startsWith(window.location.origin)) {
          event.preventDefault()
          gsap.to(overlay, {
            x: 0,
            duration: 0.5,
            ease: 'power2.inOut',
            onComplete: () => {
              window.location.href = url
            }
          })
        }
      })
    })
  }
}
